<template>
  <div class="role-auth">
    <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
      <el-row :gutter="50">
        <el-col :span="6" class="colSpan">
          <div class="roleFilter">
            <el-input
              :placeholder="$t('roleAuth.pRoleFilter')"
              size="small"
              :clearable="true"
              v-model="roleFilterText"
            ></el-input>
          </div>
          <el-tree
            :data="roleList"
            ref="roleTree"
            accordion
            :expand-on-click-node="true"
            :show-checkbox="selection"
            node-key="id"
            :props="defaultProps"
            :filter-node-method="roleFilterNode"
            @check="roleNodeCheck"
            @node-click="roleNodeClick"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span style="font-size: 14px">{{ data.name }}</span>
            </span>
          </el-tree>
        </el-col>
        <el-col :span="6">
          <div class="authFilter">
            <el-input
              :placeholder="$t('roleAuth.pAuthFilter')"
              size="small"
              :clearable="true"
              v-model="authFilterText"
            ></el-input>
          </div>
          <el-tree
            :data="menuList"
            ref="authTree"
            accordion
            :expand-on-click-node="true"
            :show-checkbox="selection"
            node-key="id"
            :check-strictly="true"
            :filter-node-method="authFilterNode"
            @node-click="menuNodeClick"
          >
            <span style="font-size: 14px" class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="data.type === 0">（{{ $t("roleAuth.mq") }}）</span>
              <span v-if="data.type === 1">（{{ $t("roleAuth.mw") }}）</span>
              <span v-if="data.type === 2">（{{ $t("roleAuth.me") }}）</span>
            </span>
          </el-tree>
        </el-col>
        <el-col :span="12">
          <span style="margin-bottom: 15px; display: block">
            <el-button type="primary" icon="el-icon-folder-checked" size="small" @click="reset">{{
              $t("roleAuth.reset")
            }}</el-button>
            <el-button
              type="success"
              icon="el-icon-guide"
              size="small"
              :disabled="loadingForm"
              @click="assignAuthority"
              >{{ $t("roleAuth.assign") }}</el-button
            >
          </span>
          <vue-scroll>
            <div class="power">
              <div v-for="(item, index) in listPower" :key="item.id" class="list-power" v-show="index == 0">
                <div class="power-title">
                  {{ item.name }}
                  <el-button
                    v-if="item.children && item.children.length > 0"
                    @click="handleCheckAllChange(item.id)"
                    type="text"
                    >{{ $t("roleAuth.check") }}</el-button
                  >
                </div>
                <el-checkbox-group v-model="power" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in item.children" :label="city.id" :key="city.id">{{
                    city.name
                  }}</el-checkbox>
                </el-checkbox-group>
                <div style="color: red" v-if="!item.children || item.children.length < 0">Nothing~</div>
              </div>
            </div>
          </vue-scroll>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RoleAuth",
    data() {
      return {
        roleFilterText: "",
        authFilterText: "",
        menuList: [],
        selection: true,
        roleId: "",
        menuId: [],
        roleAuth: {
          userName: "",
          nickName: ""
        },
        listMenu: [],
        listPower: [],
        power: [],
        checked: {},
        loadingForm: false,
        // 已选择的权限
        checkedKeys: []
      };
    },
    props: {
      roleList: Array,
      defaultProps: Object
    },
    watch: {
      roleFilterText(val) {
        this.$refs.roleTree.filter(val);
      },
      authFilterText(val) {
        this.$refs.authTree.filter(val);
      }
    },
    mounted() {
      this.loadMenu();
    },
    methods: {
      loadMenu() {
        this.loading = true;
        this.$api.request(this.$url.AuthorityRoleMenu.load).then(res => {
          if (res.code === 0) {
            // 菜单目录 外两层
            let menuList = JSON.parse(JSON.stringify(res.data));
            menuList.forEach(item => {
              if (item.children && item.children.length > 0) {
                item.children.forEach(child => {
                  delete child.children;
                });
              }
            });
            this.menuList = menuList;
            console.log(this.menuList, this.$t("auth.RoleAuth.909314-0"));

            // 权限 里两层
            let listPower = [];
            res.data.forEach(item => {
              if (item.children && item.children.length > 0) {
                listPower = [...listPower, ...item.children];
              }
            });
            this.listPower = listPower;
            console.log(this.listPower, this.$t("auth.RoleAuth.909314-1"));
          }
        });
      },
      roleNodeCheck(data) {
        let role = this.$refs.roleTree.getCheckedNodes(true, false);
        if (data.pid !== "0") {
          if (role.length > 0) {
            this.$refs.roleTree.setCheckedKeys([]);
            this.$refs.roleTree.setCheckedKeys([data.id]);
          } else {
            this.$refs.roleTree.setCheckedKeys([]);
          }
        } else {
          if (!data.children) {
            if (role.length > 0) {
              this.$refs.roleTree.setCheckedKeys([]);
              this.$refs.roleTree.setCheckedKeys([data.id]);
            } else {
              this.$refs.roleTree.setCheckedKeys([]);
            }
          } else {
            this.$refs.roleTree.setCheckedKeys([]);
          }
        }
        this.roleNodeClick(data);
      },

      roleNodeClick(data) {
        if (!this.menuList || this.menuList.length < 1) {
          this.$message.warning("Please wait for the menu to load and operate after completion.");
          return;
        }
        if (data.pid !== "0" || !data.children) {
          this.$refs.roleTree.setCheckedKeys([data.id]);
          this.$api
            .request(this.$url.AuthorityRoleMenu.listMenu, this.$method.get, {
              roleId: data.id
            })
            .then(res => {
              if (res.code === 0) {
                this.checkedKeys = res.data;
                console.log(this.checkedKeys, this.$t("auth.RoleAuth.909314-2"));
                // 左侧菜单选中
                this.$refs.authTree.setCheckedKeys(res.data);
                // 右侧权限选中
                let roleIds = [];
                this.listPower.forEach(item => {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach(m => {
                      roleIds.push(m.id);
                    });
                  }
                });
                this.power = this.getArrayIntersection(this.checkedKeys, roleIds);
              }
            });
        }
      },
      // 数组求交集
      getArrayIntersection(array1, array2) {
        const set1 = new Set(array1);
        return array2.filter(value => set1.has(value));
      },
      recursive(arr, data) {
        data.forEach(key => {
          if (key.menuType === 1) {
            arr.push(key.id);
          }
          if (key.children && key.children.length > 0) {
            this.recursive(arr, key.children);
          }
        });
      },
      // 点击菜单置前
      menuNodeClick(data) {
        if (data.children) return;
        let info = {};
        for (let i = 0; i < this.listPower.length; i++) {
          if (this.listPower[i].id === data.id) {
            info = this.listPower[i];
            this.listPower.splice(i, 1);
            break;
          }
        }
        this.listPower.unshift(info);
      },
      handleCheckAllChange(val) {
        this.listPower.forEach(key => {
          if (key.id === val) {
            key.children.forEach(m => {
              if (!this.power.includes(m.id)) {
                this.power.push(m.id);
              }
            });
            return false;
          }
        });
      },
      handleCheckedCitiesChange(value) {
        console.log(value, this.$t("auth.RoleAuth.909314-3"));
      },
      loadCheckMenu(roleId) {
        this.$api
          .request(this.$url.AuthorityRoleMenu.listMenu, this.$method.get, {
            roleId: roleId
          })
          .then(res => {
            if (res.code === 0) {
              let obj = [];
              res.data.forEach(key => {
                obj.push(key.menuId);
              });
              this.$refs.authTree.setCheckedKeys(obj);
              this.menuId = obj;
            }
          });
      },

      roleFilterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },

      authFilterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },

      assignAuthority() {
        let role = this.$refs.roleTree.getCheckedNodes(true, false);
        let auth = this.$refs.authTree.getCheckedNodes(false, true);
        this.$confirm(this.$t("roleAuth.isRole"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          let menuIds = this.$cloud.getIds(auth).concat(this.power);
          if (!role || role.length <= 0 || !role[0].id) {
            this.$message.warning(this.$t("auth.RoleAuth.909314-4"));
            return;
          }
          let obj = { id: role[0].id, menuIds: menuIds };
          this.loadingForm = true;
          this.$api
            .request(this.$url.AuthorityRoleMenu.save, this.$method.post, obj)
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("roleAuth.upAuth"),
                  type: "success"
                });
              }
              this.loadingForm = false;
            })
            .catch(() => {
              this.loadingForm = false;
            });
        });
      },

      nodeRoleUser(data) {
        this.roleId = data.id;
        if (data.pid !== "0" || (data.pid === "0" && !data.children)) {
          this.$refs.roleTree.setCheckedKeys([data.id]);
          this.loadCheckMenu(data.id);
        }
      },

      reset() {
        this.$refs.authTree.setCheckedKeys([]);
        this.power = [];
      }
    }
  };
</script>

<style lang="scss">
  .role-auth {
    .power {
      color: #606266;
    }
    .list-power {
      margin-bottom: 10px;
    }
    .power-title {
      margin-bottom: 5px;
      .el-button--text {
        margin-left: 10px;
      }
    }
  }
</style>
